import React from 'react';

import PageForumOverview from './Overview';

const PageForum = () => {
  return <PageForumOverview />;
};

export default PageForum;
